<template>
  <div class="relative max-w-md w-full">
    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
      <MagnifyingGlassIcon class="h-5 w-5 text-gray-400" />
    </div>
    <input
      v-model="searchQuery"
      type="text"
      placeholder="Search models..."
      class="w-full pl-10 pr-4 py-2 bg-white border border-gray-300 rounded-lg text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
      @keyup.enter="performSearch"
    />
    <!-- Результаты поиска (будут добавлены позже) -->
    <div 
      v-if="showResults && searchResults.length > 0"
      class="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-60 overflow-y-auto"
    >
      <div
        v-for="result in searchResults"
        :key="result.id"
        class="px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
        @click="selectModel(result)"
      >
        <div class="font-medium">{{ result.name }}</div>
        <div class="text-gray-500 text-xs">{{ result.provider }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline'
import { useRouter } from 'vue-router'

interface ModelResult {
  id: string
  name: string
  provider: string
}

const router = useRouter()

// State
const searchQuery = ref('')
const showResults = ref(false)

// Mock данные для демонстрации
const mockResults: ModelResult[] = [
  { id: '1', name: 'GPT-4', provider: 'OpenAI' },
  { id: '2', name: 'Claude-3', provider: 'Anthropic' },
  { id: '3', name: 'Gemini Pro', provider: 'Google' },
]

// Computed
const searchResults = computed(() => {
  if (!searchQuery.value.trim()) return []
  
  return mockResults.filter(model =>
    model.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    model.provider.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
})

// Watchers
watch(searchQuery, (newValue) => {
  showResults.value = newValue.length > 0
})

// Methods
function performSearch() {
  if (searchQuery.value.trim()) {
    router.push({
      name: 'models',
      query: { search: searchQuery.value }
    })
    showResults.value = false
  }
}

function selectModel(model: ModelResult) {
  // Переход к конкретной модели
  router.push({
    name: 'models',
    query: { model: model.id }
  })
  searchQuery.value = ''
  showResults.value = false
}

// Hide results when clicking outside
function handleClickOutside() {
  showResults.value = false
}

// В реальном приложении здесь будет подключение к API поиска
</script> 